import styled from 'styled-components';

const PlannerFormStyles = styled.div`
  position: relative;

  .phone-link {
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #352269;
    text-decoration: underline;
  }
  .phone-link-thank-you {
    font-family: 'source-sans-pro', sans-serif;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.69;
    -webkit-letter-spacing: normal;
    -moz-letter-spacing: normal;
    -ms-letter-spacing: normal;
    letter-spacing: normal;
    color: #4e5255;
    text-decoration: underline;
  }
  .CTAPlannerCard-chip {
    display: none;
  }
  .caption {
    display: block !important;
    a {
      color: #352269;
      text-decoration: underline;
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 14px;
    }
  }
  .submit-btn-form {
    display: flex;
    justify-content: center;
  }
  .completed-cta {
    position: relative;
  }

  .formError {
    color: #ef4b5d;
  }
  .cta-button {
    background: #0075c9;
    color: white;
    border-radius: 2px;
    border: 1px solid #0075c9;
    padding: 17px 17px;
    font: 500 12px/100% 'source-sans-pro', sans-serif;
    margin-top: 3px;
    letter-spacing: 1px;
    text-decoration: none;
    transition: 0.2s;
    text-transform: uppercase;
    font-weight: 600;
    display: inline-flex;
    align-self: center;
    &:hover {
      background: rgb(23, 158, 255);
      border: 1px solid rgb(23, 158, 255);
    }
  }

  button label {
    color: #352269 !important;
    padding-left: 10px;
  }

  button {
    .dropdown-selected-text {
      padding-left: 10px;
      color: #352269;
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 27px;
    }
  }

  .CTAPlannerCard-textContainer {
    .DXTypography,
    a {
      color: white !important;
    }
  }

  .error-message {
    color: #e83f52 !important;
    font-weight: 300 !important;
    font-size: 12px !important;
    font-family: 'source-sans-pro';
  }
`;

export default PlannerFormStyles;
